/**
 * Project colours (request 13 of round 4): one of the eight hues of the validated categorical palette, chosen per
 * project in its settings. The colour is a second cue next to the project number and name (never alone); projects
 * without a colour stay neutral. Light and dark values are CSS variables (styles.css, --pc-*).
 */
export const PROJECT_COLORS = ['blue', 'orange', 'aqua', 'yellow', 'magenta', 'green', 'violet', 'red'] as const;
export type ProjectColor = (typeof PROJECT_COLORS)[number];

export function isProjectColor(c: unknown): c is ProjectColor {
  return typeof c === 'string' && (PROJECT_COLORS as readonly string[]).includes(c);
}

/** CSS colour of a project, or undefined for a project without colour. */
export function projectColorVar(c: string | null | undefined): string | undefined {
  return isProjectColor(c) ? `var(--pc-${c})` : undefined;
}

/** Kind of task for the small type label: Forma issue, manual task (M number) or task of the internal project. */
export type TaskKind = 'forma' | 'manual' | 'internal';
export function taskKindOf(t: { source?: string | null; taskSource?: string | null; projectInternal?: boolean }): TaskKind {
  if (t.projectInternal) return 'internal';
  return (t.source ?? t.taskSource) === 'forma' ? 'forma' : 'manual';
}
